import axiosInstance from './axiosInstance';
import { ExamType } from '../types/examTypeTypes';

// Fetch all exam types
// export const getExamTypes = async (params?: {
//   subjectId?: string;
//   classLevelId?: string;
//   branchId?: string;
//   name?: string;
// }) => {
//   const response = await axiosInstance.get<ExamType[]>(
//     `/exam-types`,
//     {
//       params,
//     }
//   );

//   return response.data;
// };


export const getExamTypesWithParams = async (params : any) => {
  try {
    const response = await axiosInstance.get(`/exam-types`, {
      params,
    });
    console.log("response", response);
    return response.data;
  } catch (error) {
    console.error('Error fetching exam types:', error);
    throw error;
  }
};
